import { render, staticRenderFns } from "./ProfileBasic.vue?vue&type=template&id=8d7f235e&scoped=true&"
import script from "./ProfileBasic.vue?vue&type=script&lang=js&"
export * from "./ProfileBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7f235e",
  null
  
)

export default component.exports